
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-amber-50 to-orange-50 border-t border-amber-100 py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3">
          {/* Brand & Social */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/fdabe7c7ccee11942d3988daf4f91aee/f49c6930ed0cac90b3c370f0e31f809b.png" 
              alt="Filmora Logo" 
              className="h-7 w-auto"
            />
            <span className="text-lg font-bold text-gray-900">Filmora</span>
            
            {/* Social Icons */}
            <div className="flex items-center space-x-1.5 ml-2">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-7 h-7 flex items-center justify-center rounded-full bg-white border border-gray-100 text-gray-500 hover:text-rose-500 hover:border-rose-200 transition-all">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-7 h-7 flex items-center justify-center rounded-full bg-white border border-gray-100 text-gray-500 hover:text-rose-500 hover:border-rose-200 transition-all">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-7 h-7 flex items-center justify-center rounded-full bg-white border border-gray-100 text-gray-500 hover:text-rose-500 hover:border-rose-200 transition-all">
                <i className="ri-facebook-circle-line text-sm"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-7 h-7 flex items-center justify-center rounded-full bg-white border border-gray-100 text-gray-500 hover:text-rose-500 hover:border-rose-200 transition-all">
                <i className="ri-youtube-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Support Links */}
          <div className="flex items-center text-xs text-gray-500">
            <Link to="/privacy" className="hover:text-rose-500 transition-colors">Privacy</Link>
            <span className="mx-2">•</span>
            <Link to="/terms" className="hover:text-rose-500 transition-colors">Terms</Link>
            <span className="mx-2">•</span>
            <a href="mailto:support@filmora.me" className="hover:text-rose-500 transition-colors">Contact: support@filmora.me</a>
          </div>

          {/* Copyright */}
          <p className="text-gray-400 text-xs">
            © 2025 Filmora. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
